import { IS_BUILD_PAGE, IS_MODELS_PAGE, IS_T1_PAGE } from '../constants/environment';

/* eslint-disable no-nested-ternary */
const formType = {
  general: 'general',
  testDrive: 'test_drive',
  pricing: 'pricing',
  promotion: 'specials',
  service: 'service',
  parts: 'parts',
  requestCall: 'requestCall',
  other: 'other',
};

const requestTypeMappingCA = {
  vlp: 'VLP Vehicle Inquiry',
  vdp: 'VDP Vehicle Inquiry',
  special: 'Special Offers',
  offers: 'Contact Us', // Need to double-check with ELSP
  config: 'Configure Your Vehicle',
  mlp: 'Inventory Listing',
  fym: 'Find Your Match',
  general: 'Contact Us',
  generic: 'Contact Us',
};

type SourceType = keyof typeof requestTypeMappingCA;

export const formTypeFormatter = (
  isVehicleInfoAvailable: boolean,
  source: string,
  topicOfInterest: keyof typeof formType | '',
  isUSMarket: boolean,
  requestType: string | null,
) => {
  const isAfterSalesParts = topicOfInterest === 'parts';
  const isAfterSalesService = topicOfInterest === 'service';
  const isRequestACall = topicOfInterest === 'requestCall';

  const contact = IS_T1_PAGE ? 'Contact' : 'contact';

  const isVinSpecific = isVehicleInfoAvailable ? 'dealervin' : 'dealer';

  const genericTopic = IS_T1_PAGE ? 'generic' : 'general';

  if (requestType) return requestType.replace('-', '_');
  if (isAfterSalesParts) return 'Contact Us - Parts';
  if (isAfterSalesService) return 'Contact Us - Service';
  if (isRequestACall) return 'Request a Call';

  if (isUSMarket && topicOfInterest && !IS_MODELS_PAGE && !IS_BUILD_PAGE) {
    const formTypeOfTopic =
      topicOfInterest === 'general' ? genericTopic : formType[topicOfInterest];
    return `${contact}_dealer-${formTypeOfTopic}`;
  }

  const requstTypeCa = !isUSMarket ? requestTypeMappingCA?.[source as SourceType] : '';

  const finalRequestType = isUSMarket ? `${contact}_${isVinSpecific}-${source}` : requstTypeCa;

  return finalRequestType;
};

export default formTypeFormatter;
